<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";
// import _ from "lodash";

export default {
  page: {
    title: "Kompetensi Validator",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  computed: {
    validatorOptionsFiltered() {
      if (!this.selectedRow) return this.optionValidator;

      const usedIds = this.selectedRow.kompetensi_validator.map(
        (v) => v.idverif_validator,
      );

      return this.optionValidator.map((opt) => {
        return {
          ...opt,
          disabled: usedIds.includes(opt.idverif_validator),
        };
      });
    },
  },
  data() {
    let sortOrders = [];

    let columns = [
      { width: "50px", label: "No", name: "idverif_kompetensi_level" },
      { width: "auto", label: "Kompetensi", name: "nama_kompetensi" },
      { width: "120px", label: "Level", name: "nama_level" },
      { width: "300px", label: "Validator", name: "-" },
      { width: "100px", label: "Status", name: "-" },
      { width: "200px", label: "Aksi", name: "-" },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Kompetensi Validator",
      isWrite: 1,
      loadingTable: true,
      table_data: [],
      columns,
      sortKey: "idverif_kompetensi_validator",
      sortOrders,
      pagination: {},

      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        filter: {
          active_flag: 1,
          idlevel_kompetensi: null,
          idverif_kompetensi: null,
        },
      },

      // modal
      showModal: false,
      selectedRow: null,

      // form mapping
      form: {
        validator: null,
        validator_id: null,
        is_pengganti: 0,
        source_idvalidator: null,
      },

      optionLevel: [],
      optionKompetensi: [],
      optionValidator: [],
      showForm: false,
      isEditMode: false,
      selectedValidator: null,
    };
  },
  async mounted() {
    await this.getDataTable();

    this.getValidator();
    this.getLevel();
    this.getKompetensiFilter();

    this.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-validator",
    ) {
      this.loadingTable = true;

      return axios({
        method: "get",
        url: url,
        params: this.tableFilter,
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((res) => {
          let data = res.data.data;
          this.table_data = data.data;
          this.pagination = data;
        })
        .finally(() => (this.loadingTable = false));
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },

    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable();
    },

    refreshSelectedRow() {
      if (!this.selectedRow) return;

      const updated = this.table_data.find(
        (row) =>
          row.idverif_kompetensi_level ===
          this.selectedRow.idverif_kompetensi_level,
      );

      if (updated) {
        this.selectedRow = updated;
      }
    },

    async getValidator(search = "") {
      let res = await axios.get(
        process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/validator/all",
        {
          params: { search },
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        },
      );

      this.optionValidator = res.data.data.data;
    },

    async getLevel(search = "") {
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/level-kompetensi/all",
          {
            params: { search, limit: 100 },
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          },
        );
        const resData = response.data.data;
        this.optionLevel = Array.isArray(resData)
          ? resData
          : resData?.data || [];
      } catch (e) {
        console.error(e);
        this.optionLevel = [];
      }
    },

    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKompetensiFilter(search, loading);
      }
    },

    async getKompetensiFilter(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/verif-kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          },
        )
        .then((response) => {
          this.optionKompetensi = response.data.data.data;
          console.log(this.optionKompetensi);
          if (loading) loading(false);
        });
    },

    openManage(row) {
      this.selectedRow = row;
      this.showModal = true;
      this.showForm = false;
      this.isEditMode = false;
    },
    addMode() {
      this.resetForm();
      this.isEditMode = false;
      this.showForm = true;
    },

    editValidator(v) {
      this.resetForm();
      this.isEditMode = true;
      this.showForm = true;

      this.selectedValidator = v;

      // optional kalau mau prefill (biasanya kosong karena ganti)
      this.form.validator = null;
    },

    cancelForm() {
      this.resetForm();
      this.isEditMode = false;
      this.showForm = false;
      this.selectedValidator = null;
    },

    resetForm() {
      this.form = {
        validator_id: null,
        is_pengganti: 0,
        source_idvalidator: null,
      };
    },

    // ================= SAVE =================
    saveMapping() {
      if (!this.form.validator) {
        Swal.fire("Validator wajib dipilih");
        return;
      }

      const exists = this.selectedRow.kompetensi_validator.some(
        (v) => v.idverif_validator === this.form.validator?.idverif_validator,
      );

      if (exists) {
        Swal.fire("Validator sudah digunakan");
        return;
      }

      // limit hanya untuk ADD
      if (
        !this.isEditMode &&
        this.selectedRow.kompetensi_validator.length >= 3
      ) {
        Swal.fire("Maksimal 3 validator");
        return;
      }

      const payload = {
        idverif_kompetensi_level: this.selectedRow.idverif_kompetensi_level,
        idverif_validator: this.form.validator.idverif_validator,
        is_pengganti: this.isEditMode ? 1 : 0,
        source_idvalidator: this.isEditMode
          ? this.selectedValidator.idverif_validator
          : null,
      };

      axios({
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-validator",
        data: payload,
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
      }).then(() => {
        Swal.fire("Berhasil", "", "success");

        this.getDataTable().then(() => {
          this.refreshSelectedRow(); // 🔥 ini kunci
        });
        this.resetForm();
        this.isEditMode = false;

        this.cancelForm();
      });
    },

    statusProgressBadgeClass(status) {
      switch (status) {
        case "DONE":
          return "bg-success";
        case "ON PROGRESS":
          return "bg-warning";
        default:
          return "bg-secondary";
      }
    },

    // ================= DELETE =================
    removeValidator(item) {
      Swal.fire({
        icon: "warning",
        title: "Hapus validator?",
        showCancelButton: true,
      }).then((r) => {
        if (r.isConfirmed) {
          axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "verifikasi/kompetensi-validator/" +
              item.idverif_kompetensi_validator,
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }).then(() => {
            this.getDataTable().then(() => {
              this.refreshSelectedRow(); // 🔥 ini juga
            });
            Swal.fire("Berhasil", "", "success");
          });
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <!-- STATUS -->
          <div class="col-md-3">
            <label>Status</label>
            <v-select
              :options="[
                { label: 'Aktif', value: 1 },
                { label: 'Tidak Aktif', value: 0 },
              ]"
              label="label"
              :reduce="(opt) => opt.value"
              v-model="tableFilter.filter.active_flag"
              :clearable="false"
              @update:modelValue="getDataTable()"
            />
          </div>

          <!-- LEVEL -->
          <div class="col-md-3">
            <label>Level</label>
            <v-select
              :options="optionLevel"
              label="nama_level"
              :reduce="(opt) => opt.idlevel_kompetensi"
              v-model="tableFilter.filter.idlevel_kompetensi"
              placeholder="Pilih level"
              :clearable="true"
              @update:modelValue="getDataTable()"
            />
          </div>

          <!-- KOMPETENSI -->
          <div class="col-md-4">
            <label>Kompetensi</label>
            <v-select
              class="style-chooser"
              :options="optionKompetensi"
              :reduce="(item) => item.nama_kompetensi"
              label="nama_kompetensi"
              v-model="tableFilter.filter.nama_kompetensi"
              placeholder="Filter Kompetensi"
              @search="filterKompetensi"
              @update:modelValue="getDataTable()"
            />
          </div>
        </div>

        <datatable
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="loadingTable">
              <td colspan="99" class="text-center">Loading...</td>
            </tr>

            <tr v-else-if="table_data.length == 0">
              <td colspan="99" class="text-center">Data Tidak Tersedia</td>
            </tr>

            <tr v-else v-for="(row, i) in table_data" :key="i">
              <td>{{ i + 1 }}</td>

              <td>{{ row.nama_kompetensi }}</td>
              <td>{{ row.nama_level }}</td>

              <!-- ✅ VALIDATOR CHIPS -->
              <td>
                <div class="d-flex flex-column gap-1">
                  <div
                    v-for="v in row.kompetensi_validator"
                    :key="v.idverif_kompetensi_level"
                    class="d-flex align-items-center gap-1"
                  >
                    <span
                      class="badge"
                      :class="v.is_pengganti == 1 ? 'bg-secondary' : 'bg-primary'"
                    >
                      {{ v.validator?.user?.name }}
                      <!-- <small v-if="v.is_pengganti">(P)</small> -->
                    </span>

                    <span
                      class="badge"
                      :class="statusProgressBadgeClass(v.status_progress)"
                    >
                      {{ v.status_progress }}
                    </span>
                  </div>

                  <span
                    v-if="row.kompetensi_validator.length === 0"
                    class="text-muted"
                  >
                    -
                  </span>
                </div>
              </td>

              <!-- STATUS -->
              <td class="text-center">
                <span
                  class="badge"
                  :class="
                    row.kompetensi_validator.length === 3
                      ? 'bg-success'
                      : 'bg-warning'
                  "
                >
                  {{ row.kompetensi_validator.length }}/3
                </span>
              </td>

              <!-- ACTION -->
              <td class="text-center">
                <button class="btn btn-sm btn-primary" @click="openManage(row)">
                  <i class="fa fa-wrench me-1"></i>
                  Setting Validator
                </button>
              </td>
            </tr>
          </tbody>
        </datatable>

        <pagination :pagination="pagination" @to-page="toPage" />
      </div>
    </div>
    <b-modal
      v-model="showModal"
      size="lg"
      title="Setting Validator"
      hide-footer
    >
      <div v-if="selectedRow">
        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0">Daftar Validator</h6>

          <button
            class="btn btn-sm btn-primary"
            :disabled="selectedRow.kompetensi_validator.length >= 3"
            @click="addMode"
          >
            <i class="fa fa-plus me-1"></i>
            Tambah
          </button>
        </div>

        <hr />

        <!-- ================= LIST VALIDATOR ================= -->
        <div class="mb-3">
          <!-- <h6 class="mb-2">Daftar Validator</h6> -->

          <div
            v-for="v in selectedRow.kompetensi_validator"
            :key="v.id"
            class="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
          >
            <div>
              <strong>{{ v.validator?.user?.name ?? "-" }}</strong>
              <br />
              <small class="text-muted" v-if="v.is_pengganti">
                Pengganti dari {{ v.validator_old?.user?.name }}
              </small>
            </div>

            <div class="btn-group">
              <!-- EDIT = GANTI -->
              <button class="btn btn-sm btn-warning" @click="editValidator(v)">
                <i class="fa fa-edit"></i>
                Ganti
              </button>

              <button class="btn btn-sm btn-danger" @click="removeValidator(v)">
                <i class="fa fa-trash"></i>
                Hapus
              </button>
            </div>
          </div>

          <div v-if="selectedRow.kompetensi_validator.length === 0">
            <small class="text-muted">Belum ada validator</small>
          </div>
        </div>

        <hr />

        <!-- ================= FORM ================= -->
        <div v-if="showForm" class="card border mt-3">
          <div class="card-body">
            <!-- TITLE -->
            <h6 class="mb-3">
              {{ isEditMode ? "Ganti Validator" : "Tambah Validator" }}
            </h6>

            <!-- SELECT -->
            <div class="mb-3">
              <label class="form-label">Pilih Validator</label>
              <v-select
                :options="validatorOptionsFiltered"
                label="name"
                v-model="form.validator"
                :selectable="(option) => !option.disabled"
              >
                <template #option="option">
                  <div :class="{ 'text-muted': option.disabled }">
                    {{ option.name }}
                    <small v-if="option.disabled">(sudah dipakai)</small>
                  </div>
                </template>
              </v-select>
            </div>

            <!-- INFO EDIT -->
            <div v-if="isEditMode" class="mb-3">
              <small class="text-muted">
                Validator akan menggantikan:
                <strong>{{ selectedValidator?.validator?.user?.name }}</strong>
              </small>
            </div>

            <!-- ACTION -->
            <div class="text-end">
              <button class="btn btn-secondary me-2" @click="cancelForm">
                <i class="fa fa-arrow-left me-1"></i>
                Batal
              </button>

              <button class="btn btn-success" @click="saveMapping">
                <i class="fa fa-save me-1"></i>
                {{ isEditMode ? "Ganti Validator" : "Tambah Validator" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
